import styled from "styled-components";
import { Modal as BaseModal } from "@wrstudios/components";

export const Container = styled.div`
  display: flex;
  position: relative;

  ${({ theme }) => theme.media.lg`
    flex-direction: column;
  `}
`;

export const Sidebar = styled.div`
  flex-shrink: 0;
  width: 34.6rem;
  height: calc(100vh - 12rem);
  padding: 2.4rem;
  overflow: auto;
  position: sticky;
  top: 6rem;

  ${({ theme }) => theme.media.lg`
    width: 100%;
    height: auto;
    position: static;
  `}
`;

export const Bullet = styled.span`
  display: inline-block;
  color: ${({ theme }) => theme.styleGuide.colors.gray[700]};
`;

export const Content = styled.div`
  width: 100%;
  padding: 0 4.8rem 4.8rem 4.8rem;
  background-color: ${({ theme }) => theme.styleGuide.colors.white};

  ${({ theme }) => theme.media.lg`
    padding: 2.4rem;
    order: -1;
  `}

  svg {
    ${({ theme }) => theme.media.sm`
      height: 30rem;
    `}
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  margin-top: 4.8rem;
  align-items: flex-start;
  justify-content: space-between;
`;

export const Title = styled.h2`
  font-size: 4.8rem;
  font-weight: 600;
  line-height: 5.2rem;
  margin-bottom: 1.2rem;
  color: ${({ theme }) => theme.live.colors.primary};

  ${({ theme }) => theme.media.sm`
    font-size: 3.2rem;
    line-height: 3.5rem;
  `}
`;

export const SubTitle = styled.span`
  display: inline-block;
  font-size: 2.4rem;
  font-weight: 600;
  line-height: 3rem;
  margin-left: 0.8rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[700]};

  ${({ theme }) => theme.media.sm`
    font-size: 1.5rem;
    line-height: 1.8rem;
  `}
`;

export const Info = styled.button`
  width: 4rem;
  height: 4rem;
  margin: -0.2rem -1.3rem 0 0;
  padding: 0;
  appearance: none;
  cursor: pointer;

  svg {
    width: 1.4rem;
    height: 2rem;
    fill: ${({ theme }) => theme.styleGuide.colors.gray[900]};
  }
`;

export const Description = styled.div`
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 2.2rem;
  margin-bottom: 2rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[900]};

  ${({ theme }) => theme.media.sm`
    font-size: 1.7rem;
    line-height: 2.4rem;
  `}
`;

export const Value = styled.span`
  color: ${({ theme }) => theme.live.colors.primary};
`;

export const Grid = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  margin: 0 -2.4rem;

  ${({ theme }) => theme.media.sm`
    margin: 0;
  `}
`;

export const Cell = styled.div`
  padding: 0 2.4rem;

  ${({ theme }) => theme.media.sm`
    padding-left: 0;
    padding-right: 1.2rem;
  `}

  &:last-child {
    ${({ theme }) => theme.media.sm`
      padding-right: 0;
    `}
  }
`;

export const DividerCell = styled(Cell)`
  padding: 0;

  ${({ theme }) => theme.media.sm`
    display: none;
  `}
`;

export const Divider = styled.div`
  flex-shrink: 0;
  width: 0.1rem;
  height: 3.6rem;
  background-color: ${({ theme }) => theme.styleGuide.colors.gray[600]};
`;

export const ModalContent = styled(BaseModal.Content)`
  width: 100%;
  max-width: 75.4rem;
`;

export const ModalText = styled.p`
  font-size: 1.4rem;
  line-height: 2rem;
  margin: 0 0 2.4rem;

  ${({ theme }) => theme.media.sm`
    font-size: 1 .5rem;
  `}
`;
